import loadable from '@loadable/component';

// 懒加载组件
const OperationDeliveryQuery = loadable(() => import('./operationDeliveryQuery/OperationDeliveryQuery.js'));
const OperationDeliveryModify = loadable(() => import('./operationDeliveryQuery/operationDeliveryModify/OperationDeliveryModify'));
const OperationDeliveryDetailQuery = loadable(() => import('./operationDeliveryQuery/operationDeliveryDetailModal/operationDeliveryDetailModal'));
const CstStatementConfirmationManagement = loadable(() => import('./cstStatementConfirmationManagement/CstStatementConfirmationManagement'));
const CstStatementConfirmationModify = loadable(() => import('./cstStatementConfirmationManagement/cstStatementConfirmationModify/CstStatementConfirmationModify'));
const PaymentQuery = loadable(() => import('./paymentQuery/PaymentQuery'));
const PaymentModify = loadable(() => import('./paymentQuery/paymentModify/PaymentModify'));
const InvoiceManagement = loadable(() => import('./invoiceManagement/InvoiceManagement'));
const StockUpBarcodeManagement = loadable(() => import('./stockUpBarcodeManagement/StockUpBarcodeManagement'));
const ReagentDeliveryQuery = loadable(() => import('./reagentDeliveryQuery2308/ReagentDeliveryQuery'));
const ReagentDeliveryModify = loadable(() => import('./reagentDeliveryQuery2308/deliveryModify/DeliveryModify'));

export const subRoutes = [
  {
    path: '/OperationDeliveryQuery',
    component: OperationDeliveryQuery
  },
  {
    // 254003高值发货单管理 -- 发货单明细编辑
    path: '/OperationDeliveryModify',
    component: OperationDeliveryModify
  },
  {
    // 254006高值发货单管理查询
    path: '/operationDeliveryDetailQuery',
    component: OperationDeliveryDetailQuery
  },
  {
    // 801258001 销售结算确认管理
    path: '/CstStatementConfirmationManagement',
    component: CstStatementConfirmationManagement
  },
  {
    // 801258001 销售结算确认管理 - 明细编辑
    path: '/CstStatementConfirmationModify',
    component: CstStatementConfirmationModify
  },
  {
    // 801258003 付款单管理
    path: '/PaymentQuery',
    component: PaymentQuery
  },
  {
    // 801258003 付款单管理 - 明细编辑
    path: '/PaymentModify',
    component: PaymentModify
  },
  {
    // 801258004 供应商发票管理
    path: '/InvoiceManagement',
    component: InvoiceManagement
  },
  {
    // 801258004 供应商发票管理
    path: '/StockUpBarcodeManagement',
    component: StockUpBarcodeManagement
  },
  {
    // M801253010 【江阴】试剂发货单管理
    path: '/ReagentDeliveryQuery',
    component: ReagentDeliveryQuery
  },
  {
    // M801253010 【江阴】试剂发货单管理--明细编辑页
    path: '/ReagentDeliveryModify',
    component: ReagentDeliveryModify
  }
];
